import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "container",
    "leftButton",
    "rightButton"
  ]

  connect() {
    this.toggleScrollControls()
  }

  toggleScrollControls() {
    const tileCount = this.containerTarget.children.length

    if (tileCount > 4) {
      this.containerTarget.classList.add("mask-fade")
    } else {
      this.leftButtonTarget.classList.add("hidden")
      this.rightButtonTarget.classList.add("hidden")
      this.containerTarget.classList.remove("mask-fade")
    }
  }

  left() {
    this.containerTarget.scrollBy({ left: -352, behavior: "smooth" })
  }

  right() {
    this.containerTarget.scrollBy({ left: 352, behavior: "smooth" })
  }
}
